// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../utils/api';
import { useBranding } from '../context/BrandingContext';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null); // { message }
  const { branding } = useBranding();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await forgotPassword(email);
      setResult(r.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div style={{ marginBottom: 24, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700 }}>
            {branding.logo_url ? <img className="logo-img" src={branding.logo_url} alt={branding.brand_name} /> : <span className="logo-dot" />}
            {branding.brand_name}
          </div>
          <div style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 4 }}>Reset your password</div>
        </div>

        {!result ? (
          <form onSubmit={handleSubmit}>
            <p style={{ fontSize: 13, color: 'var(--gray-600)', marginBottom: 20 }}>
              Enter your work email and we'll send a password reset link to it.
            </p>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com"
                autoFocus
                required
              />
            </div>
            {error && <p className="error-text" style={{ marginBottom: 10 }}>{error}</p>}
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Sending link...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div>
            <div style={{ background: 'var(--primary-light)', border: '0.5px solid #bfdbfe', borderRadius: 8, padding: 14, marginBottom: 16, fontSize: 13, color: 'var(--primary)' }}>
              {result.message || 'If that email is registered, a password reset link has been sent to it.'}
            </div>
            <p style={{ fontSize: 12, color: 'var(--gray-400)' }}>
              The link is valid for 2 hours. Check your inbox (and spam folder). If it doesn't arrive, ask an admin to reset your password from Settings.
            </p>
          </div>
        )}

        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <Link to="/login" style={{ fontSize: 12, color: 'var(--gray-400)', textDecoration: 'none' }}>
            <i className="ti ti-arrow-left" style={{ fontSize: 11 }} /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
